<template>
  <div class="bg-white border-b border-gray-200 mb-6">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div
          v-for="tier in sortedTiers"
          :key="tier.id"
          :class="[
            'relative border rounded-lg p-4 text-left transition-all duration-200',
            isActiveTier(tier.id) 
              ? 'border-gray-200 bg-gray-50' 
              : 'border-gray-200 bg-white'
          ]"
        >
          <!-- Tier Title with Active Badge -->
          <div class="flex items-center justify-between mb-2">
            <div class="flex items-center gap-1">
              <h3 class="text-lg font-semibold text-gray-900">
                {{ $t('Stufe') }} {{ tier.name.replace(/^(Tier|Stufe)\s*/i, '').replace(/^0/, '') }}
              </h3>
              <TierInfoTooltip v-if="tier.id === sortedTiers[0]?.id" />
            </div>
            <span v-if="isActiveTier(tier.id)" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-200 text-gray-700">
              {{ $t('Aktiv') }}
            </span>
          </div>
          
          <!-- Tier Threshold -->
          <div class="text-2xl font-bold text-gray-900 mb-1">
            {{ formatCurrency(tier.revenueThreshold) }}
          </div>
          
          <!-- Minimum Order Value Label -->
          <p class="text-sm text-gray-500">
            {{ $t('Mindestbestellwert') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import TierInfoTooltip from '@/components/TierInfoTooltip.vue'

type TierData = PartnerPortal.Xhosa.Contracts.DTOs.ResellerPricingTierDto

interface Props {
  tiers: TierData[]
  currentTierId: number
  currency: string
}

const props = defineProps<Props>()

// Sort tiers by ID to ensure correct order (Tier 1, 2, 3)
const sortedTiers = computed(() => {
  return [...props.tiers].sort((a, b) => a.id - b.id)
})

const isActiveTier = (tierId: number): boolean => {
  return tierId === props.currentTierId
}

const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: props.currency || 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount)
}
</script>